var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tech-background"},[_c('div',{staticClass:"grid-bg"}),_c('canvas',{ref:"particleCanvas",staticClass:"particle-canvas"}),_c('div',{staticClass:"geometry-decoration"})])
}
var staticRenderFns = []

export { render, staticRenderFns }